module.exports = __webpack_public_path__ + "static/media/8900_Bedroom.39963df3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_Bedroom.jpg
// module id = 570
// module chunks = 0